import { render, staticRenderFns } from "./ConversionDetail.vue?vue&type=template&id=255b72a0"
import script from "./ConversionDetail.vue?vue&type=script&lang=js"
export * from "./ConversionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports